import React, { useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./GameFilters.scss";
import ChevronDownIcon from "../../icons/ChevronDownIcon";

interface GameFiltersProps {
  selectedFilterId: number;
  handleFilterSelection: (filterId: number) => void;
}

function useGameFilters() {
  const { t } = useTranslation("games");

  return useMemo(
    () => [
      { id: 1, title: t("pending_games"), emoji: "⌛️" },
      { id: 2, title: t("game_requests"), emoji: "⏰" },
      { id: 3, title: t("live_games"), emoji: "🎮" },
      { id: 4, title: t("favorites"), emoji: "❤️" },
      { id: 5, title: t("popular_games"), emoji: "🔥" },
    ],
    [t]
  );
}

export default function GameFilters({
  selectedFilterId,
  handleFilterSelection,
}: GameFiltersProps) {
  const gameFilters = useGameFilters();

  const selectedFilter = useMemo(
    () => gameFilters[selectedFilterId - 1],
    [gameFilters, selectedFilterId]
  );
  return (
    <Dropdown className="allow-pointer-events GamesFiltersDropdown">
      <Dropdown.Toggle className="p-0 GamesFiltersToggle">
        <span>{selectedFilter.emoji}</span>
        {selectedFilter.title}
        <span className="ms-1">
          <ChevronDownIcon />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-2 GamesFiltersMenu">
        {gameFilters.map(({ id, title, emoji }) => (
          <Dropdown.Item
            key={title}
            as="button"
            className={`Grotesk MenuItem ${
              selectedFilterId === id ? "active" : undefined
            }`}
            onClick={() => handleFilterSelection(id)}
          >
            <span>{emoji}</span>
            {title}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
